import { getValue } from "@utils/lodash";
import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import FileLogSvgComponent from "@assets/svg-components/file-log";

function BulkViewLogsDropdown(props: any) {
  const { dropdownOptions } = props;
  
  return (
    <div className="filterbar-icon-button-holder">
      <UncontrolledDropdown className="common-dropdown">
        <DropdownToggle className="px-0 text-center">
          <div className="add-filter-wrapper__filter-container ms-0">
            <div className="cursor-pointer">
              <FileLogSvgComponent size={24} color="#5f6368" />
              <p className="small_text__12">{"LOGS"}</p>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu>
          {getValue(dropdownOptions, `length`, 0) > 0 &&
            dropdownOptions.map((item: object, index: number) => {
              return (
                <DropdownItem
                  key={index}
                  onClick={() => {
                    const logId = getValue(item, `logId`, "");
                    if (logId && props.handleNavigateReportLogs) {
                      props.handleNavigateReportLogs(logId);
                    }
                  }}
                >
                  {getValue(item, `label`, "")}
                </DropdownItem>
              );
            })}
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
}

export default BulkViewLogsDropdown; 